{
  "backToDevices": "Volver a Dispositivos",
  "connectionsTitle": "Conexiones",
  "currentStatusTitle": "Estado actual",
  "deviceInfoTitle": "Información del dispositivo",
  "helpBody": "El perfil del dispositivo le permite administrar dispositivos individuales. Puede cambiar la configuración de un dispositivo, ver su historial de actualizaciones y acciones ejecutadas, entre otras cosas.",
  "deviceIsNotCenterPivot": "Esta función solo está disponible para dispositivos configurados como pivotes centrales.",
  "deviceLocationNotAvailable": "Ubicación del dispositivo no disponible",
  "deviceNotFoundWithCodaDeviceAlias": "No se encontró ningún dispositivo con el alias {{codaDeviceAlias}}.",
  "linkToActionHistory": "Comandos",
  "linkToConfiguration": "Configuración",
  "linkToEventHistory": "Historia",
  "linkToLanding": "Hogar",
  "linkToNotifications": "Notificaciones",
  "locationTitle": "Ubicación",
  "noWarnings": "No se encontraron advertencias para este dispositivo.",
  "note": "Nota",
  "title": "Perfil del dispositivo",
  "warningsTitle": "Advertencias"
}
